function informObj () {}
/**
 * @param msg 弹层信息
 * @param showTime 弹层显示时间
 * @param zIndex 弾层层级
 */
informObj.prototype.inform = function(msg, showTime, zIndex) {
	var self = this;

	// 若遮罩和文本部分id不存在，创建元素并赋id
	if (!document.querySelector('#js-mask')) {
	  	self.mask = document.createElement('div');
    	self.bubble = document.createElement('div');
        self.mask.setAttribute('id', 'js-mask');
        self.bubble.setAttribute('id', 'js-bubble');
        // 添加ARIA属性
        self.bubble.setAttribute('role', 'alert');
        document.body.appendChild(self.mask);
        document.body.appendChild(self.bubble);
    } else {
        if (!self.mask) self.mask = document.querySelector('#js-mask');
        if (!self.bubble) self.bubble = document.querySelector('#js-bubble');
    }

    self.mask.style.display = 'block';
    self.bubble.style.display = 'inline-block';
    self.bubble.innerHTML = msg || '';
    // 可设置z-index
    if (zIndex != undefined) {
        self.mask.style.zIndex = zIndex;
        self.bubble.style.zIndex = zIndex;
    }

    // 渐显，耗时1s
    setTimeout(function() {
        self.mask.style.opacity = 0.5;
        self.bubble.style.opacity = 0.75;   
    }, 0);

    var time = 0;
    var regExp = new RegExp(/^[1-9]\d*$/); // 匹配正整数
    if (showTime && regExp.test(showTime)) {
        time = parseInt(showTime);
    }

    // 渐隐，耗时1s
    setTimeout(function() {
        self.mask.style.opacity = 0;
        self.bubble.style.opacity = 0;
    }, 1000 + time);
    // 隐藏
    setTimeout(function() {
        self.mask.style.display = 'none';
        self.bubble.style.display = 'none';
    }, 2000 + time);
}

module.exports = new informObj();